<template>
  <el-drawer
    title="用户列表"
    :visible.sync="drawer"
    :direction="direction"
    :with-header="false"
    :before-close="handleClose"
    class="drawer"
  >
    <div class="page_view">
             
        <div class="tool_view">
             <el-button type="primary" @click="onAddUser">增加用户</el-button>
        </div>
      <el-table
        ref="tableArr"
        v-loading="isLoading"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="getRowClass"
      >
        <template v-for="item in items">

          <el-table-column v-if="item.id=='user_type'" :prop="item.id"  :key="item.name"
            header-align="center"
            align="center"
            :label="item.name">
            <template slot-scope="scope">
                <template v-if="scope.row.user_type == 0">澳门</template>
                <template v-else>香港</template>
            </template>
          </el-table-column>
          <el-table-column
           v-else
            :key="item.name"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
          ></el-table-column>

        </template>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          class="operate"
          width="240"
        >
          <template scope="scope">
            <div >
              <el-button @click="onHandle(scope.row)" size="mini" type="success">编辑</el-button>
              <el-button @click="onDelete(scope.row)" size="mini" type="danger" v-if="scope.row.username!='admin'">删除</el-button>
              <el-button @click="onLook(scope.row)" size="mini" type="primary">查看</el-button>

            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10,15]"
        :page-size="paginate"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagecount"
      ></el-pagination>
    </div>
  </el-drawer>
</template>
<script>
export default {
  name: "user-edit",
  data() {
    return {
        drawer: false,
        direction: "rtl",
        tableData: [],
        paginate:10,
        pagecount:0,
        currentPage:1,
        items: [
            { name: "编号", id: "id" },
            { name: "帐号", id: "username" },
            { name: "类型", id: "user_type" },
        ]
    };
  },
  methods: {
    show() {
      this.drawer = true;
      this.getData();
    },
    getData(page=1,size=10) {
      var self = this;
      this.$http.get("/admin/xzt/users",{size:size,page:page}).then(res => {
        console.log("res:", res);
        self.tableData = res.data.data;
        self.pagecount = res.data.total;
      });
    },
    onHandle(value)
    {
      this.$emit("sucess",value);
    //   this.drawer = false;
    },
    onLook(value){
      this.$emit("look",value);
    },
    onDelete(value){
      if(value.username=="admin"){
        this.$message.error("不能删除此帐号。。。。。");
        return;
      }
      this.$http.post("/admin/xzt/deleteuser",{id:value.id}).then(res => {
        console.log("res:", res);
       this.getData();
      });
    },
    onAddUser(){
        this.$emit("sucess");
    },
    handleClose() {
      this.drawer = false;
    },
     handleCurrentChange(value)
    {
      console.log("value",value);
      this.currentPage = value
      this.getData(this.currentPage,this.paginate);
    },
    handleSizeChange(size)
    {
        this.paginate = size;
        this.getData(this.currentPage,this.paginate);
    },
  }
};
</script>

<style lang="less">
.tool_view{
    text-align: left;
    padding:10px;
    border-bottom: 1px solid #ededed;
}
.drawer{
    
    .el-drawer__body{
        height: 100vh;
        overflow: scroll;
    }
    .el-pagination{
        padding:10px;
    }
}
</style>